import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";

import { SEARCH_SURVEY_STRUCTURE } from "constants/actions";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  const dispatch = useDispatch();
  const [searchBox, setSearchBox] = useState("");

  const { get_survey_structure_search } = useSelector(
    (state) => ({
      get_survey_structure_search: state.surveystructure.search,
    }),
    shallowEqual
  );

  useEffect(() => {
    setSearchBox(get_survey_structure_search);
  }, [get_survey_structure_search]);

  function OnButtonClick() {
    dispatch({
      type: SEARCH_SURVEY_STRUCTURE,
      payload: searchBox,
    });
    setSearchTerm(searchBox);
  }

  function ClearSearch() {
    dispatch({
      type: SEARCH_SURVEY_STRUCTURE,
      payload: "",
    });
    setSearchTerm('');
  }
  return (
    <div className="flex items-center gap-2 rounded-md border bg-background p-3">
      <Input
        value={searchBox}
        onChange={(e) => setSearchBox(e.target.value)}
        placeholder="Search..."
        className="flex-1"
      />
      <Button onClick={OnButtonClick}>Search</Button>
      <Button variant="secondary" onClick={ClearSearch}>Clear</Button>
    </div>
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
};

export default SearchBar;
